var _ellipse, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopupCloseButton = function SvgPopupCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 31.9512,
    rx: 32,
    ry: 31.9512,
    fill: "#766699"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.999218,
    height: 28.9785,
    transform: "matrix(0.698129 0.715972 -0.717036 0.697036 41.7783 21.2329)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999259,
    height: 28.9773,
    transform: "matrix(-0.717036 0.697036 -0.698129 -0.715972 42.2109 41.7153)",
    fill: "white"
  })));
};
export default SvgPopupCloseButton;